/**
 * Formatação de moeda isolada da feature de pipeline.
 *
 * O repo não tem um helper central de moeda (só usos pontuais de
 * `Intl.NumberFormat` em billing/shopify), então mantemos um aqui para não
 * tocar o core. Segue o mesmo estilo do ShopifyOrderItem: `Intl.NumberFormat`
 * com `style: 'currency'`, 2 casas decimais, USD por padrão.
 */

const DEFAULT_CURRENCY = 'USD';

/**
 * Formata um valor monetário (ex.: 1234.5 -> "$1,234.50").
 * Valores nulos/indefinidos/NaN viram 0 para nunca quebrar o layout.
 * @param {number} amount
 * @param {string} [currency='USD']
 * @returns {string}
 */
export const formatMoney = (amount, currency = DEFAULT_CURRENCY) => {
  const value = Number(amount);
  const safe = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currency || DEFAULT_CURRENCY,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
};

export default formatMoney;
